export const TokenKey = 'admin_token'

export const UserTokenKey = 'user_token'
export const ActivateToken = 'activate_token'

export const expiredTimeKey = 'expired_time'

export function getToken() {
  return window.localStorage.getItem(TokenKey)
}

export function setToken(token) {
  // setExpiredTime()
  console.log('aaaa',token)
  window.localStorage.setItem(UserTokenKey,token)
  return window.localStorage.setItem(TokenKey,token)
}

export function removeToken() {
  return window.localStorage.removeItem(TokenKey)
}



//激活token
export function getActivateToken() {
  return window.localStorage.getItem(ActivateToken)
}

export function setActivateToken(token) {
  return window.localStorage.setItem(ActivateToken,token)
}

export function removeActivateToken() {
  return window.localStorage.removeItem(ActivateToken)
}

//计算无操作时长
export function setExpiredTime() {
  const currentTime = new Date().getTime() + (1000 * 15 * 60)
  window.localStorage.setItem(expiredTimeKey, currentTime + '')
}
